module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/343.378d2ca8.png";